module.exports = {
          srcSet: __webpack_public_path__ + "aae7b5150d0dc95c634646647b29aabb-160.png"+" 160w",
          images:[ {path: __webpack_public_path__ + "aae7b5150d0dc95c634646647b29aabb-160.png",width: 160,height: 127}],
          src: __webpack_public_path__ + "aae7b5150d0dc95c634646647b29aabb-160.png",
          toString:function(){return __webpack_public_path__ + "aae7b5150d0dc95c634646647b29aabb-160.png"},
          
          width: 160,
          height: 127
        }